// extracted by mini-css-extract-plugin
module.exports = {"attention":"bm_fK"};